import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import { UndoOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { Button, Row, Col, Typography } from 'antd';
import { FormikDatePicker, FormikInput, FormikButton } from '../../Components/Formik';
import InvoicePicklistReportActions from '../../Stores/InvoicePicklistReport/Actions';

const { Text } = Typography;

class CriteriaForm extends React.PureComponent {
  render() {
    const { intl, criteria, sorts, pagination, reportIsLoading, fetchReport } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={criteria}
        onSubmit={(values, formikBag) => {
          fetchReport(values, sorts, pagination.pageSize, 1, formikBag);
        }}
      >
        {({ dirty, isSubmitting, handleSubmit, handleReset }) => (
          <Form>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'invoice_doc_code' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="doc_code"
                  component={FormikInput}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'invoice_doc_date' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="doc_date"
                  component={FormikDatePicker}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[0, 16]}>
              <Col span={24}>
                <Button
                  disabled={!dirty}
                  loading={isSubmitting || reportIsLoading}
                  onClick={handleReset}
                  icon={<UndoOutlined />}
                  type="primary"
                >
                  {intl.formatMessage({ id: 'reset' })}
                </Button>

                <Field
                  name="submit_action"
                  value="run_report"
                  component={FormikButton}
                  loading={isSubmitting || reportIsLoading}
                  onClick={handleSubmit}
                  label={intl.formatMessage({ id: 'run_report' })}
                  icon={<PlayCircleOutlined />}
                  type="primary"
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    );
  }
}

CriteriaForm.propTypes = {
  intl: PropTypes.object,
  criteria: PropTypes.object,
  sorts: PropTypes.arrayOf(PropTypes.object),
  pagination: PropTypes.object,
  reportIsLoading: PropTypes.bool,
  fetchReport: PropTypes.func
};

CriteriaForm.defaultProps = {
  intl: {},
  criteria: {},
  sorts: [],
  pagination: {
    current: 1,
    pageSize: 20,
    total: 0
  },
  reportIsLoading: false,
  fetchReport() {}
};

const mapStateToProps = state => ({
  criteria: state.invoicePicklistReport.criteria,
  sorts: state.invoicePicklistReport.sorts,
  pagination: state.invoicePicklistReport.pagination,
  reportIsLoading: state.invoicePicklistReport.reportIsLoading
});

const mapDispatchToProps = dispatch => ({
  fetchReport: (criteria, sorts, pageSize, page, formikBag) =>
    dispatch(
      InvoicePicklistReportActions.invoicePicklistReportFetch(
        criteria,
        sorts,
        pageSize,
        page,
        formikBag
      )
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CriteriaForm));
